<div>
    <mat-form-field appearance="outline" class="!hidden" [formGroup]="group">
        <input matInput [formControlName]="field.name" readonly (click)="editDataInput()" />
    </mat-form-field>
    <mat-form-field class="form-full-width" appearance="outline">
        <i
            matPrefix
            *ngIf="field?.leadingIcon"
            [ngClass]="'mdi mdi-' + field?.leadingIcon"
            class="input_leading-icon"
        ></i>
        <mat-label>{{ field.label }}</mat-label>
        <input
            matInput
            class="select-input-tree"
            (click)="!field.disabled ? editDataInput() : null"
            readonly
            [formControl]="formControl"
            [required]="field.required"
            [fuiTooltip]="tooltip | async"
        />
        <mat-hint *ngIf="field.hint" [innerHtml]="field.hint"></mat-hint>
        <fui-button
            *ngIf="group.get(field.name).value"
            (clickEvent)="group.get(field.name).setValue(null); group?.get(field.name)?.markAsDirty()"
            tabindex="-1"
            matSuffix
            [disabled]="field.disabled"
            [icon]="'close'"
            [title]="appService.language_dictionary.system_clear"
            [type]="'button-icon'"
            [borderRadius]="'circle'"
            [color]="'neutral'"
            [height]="'mini'"
            [iconSize]="16"
            [disabled]="field.disabled"
        >
        </fui-button>
        <fui-button
            matSuffix
            (clickEvent)="editDataInput()"
            [ngClass]="'input_trailing-button !ml-0'"
            [icon]="'pencil-outline'"
            iconSize="20"
            [title]="appService.language_dictionary.system_edit"
            [type]="'button-icon'"
            [borderRadius]="'circle'"
            [color]="'neutral'"
            [height]="'mini'"
            [disabled]="field.disabled"
        >
        </fui-button>
        <ng-container *ngFor="let validation of field.validations" ngProjectAs="mat-error">
            <mat-error
                *ngIf="group.get(field.name)?.hasError(validation.name)"
                [innerHTML]="
                    validation.name === 'serverError' ? group.get(field.name).errors?.serverError : validation.message
                "
            >
            </mat-error>
        </ng-container>
    </mat-form-field>
</div>
